// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__DDjpV","loaderOuter":"PageOverlayLoader_loaderOuter__1NrnH"};